
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.458 2.96h-.699a.35.35 0 00-.349.35v4.895l2.566 1.866a.35.35 0 00.488-.077l.41-.565a.35.35 0 00-.076-.488L7.807 7.493V3.31a.35.35 0 00-.35-.349"}}),_c('g',{attrs:{"clip-path":"url(#clip-D4B7E742-823C-4CA6-A202-24F5FBB2ED3C)"}},[_c('path',{attrs:{"d":"M17.593 16.416l-4.276-4.276a.418.418 0 00-.3-.123h-.283a7.272 7.272 0 001.694-4.682A7.308 7.308 0 001.931 2.202L.6.892a.354.354 0 00-.6.251v3.73c0 .195.158.354.354.354h3.781a.354.354 0 00.249-.606L2.937 3.195a5.874 5.874 0 014.183-1.74 5.89 5.89 0 015.893 5.893 5.89 5.89 0 01-5.893 5.894 5.873 5.873 0 01-3.924-1.494.355.355 0 00-.488.012l-.5.5a.354.354 0 00.013.513 7.281 7.281 0 004.904 1.884 7.271 7.271 0 004.674-1.704v.282c0 .113.046.219.123.3L16.2 17.81a.423.423 0 00.598 0l.797-.796a.423.423 0 000-.599"}})])])
          )
        }
      }
    